import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
		'activity-male-tai-chi-yoga-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
		'activity-male-tai-chi-walking-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-walking-al&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
	},
]

export default config
